// src/ai/client.ts — browser-safe caller for our Anthropic edge function.
// Never calls Anthropic directly; never touches an API key.
import { supabase } from '../supabase';
export class AIError extends Error {
    code;
    status;
    constructor(code, message, status) {
        super(message);
        this.code = code;
        this.status = status;
    }
}
const FUNCTION_PATH = '/functions/v1/anthropic-proxy';
export async function aiGenerate(input) {
    const url = import.meta.env.VITE_SUPABASE_URL;
    if (!url || url.includes('REPLACE_ME')) {
        throw new AIError('setup_required', 'AI is not configured yet. Finish the setup wizard.');
    }
    const { data: session } = await supabase.auth.getSession();
    const jwt = session?.session?.access_token ?? '';
    const r = await fetch(url + FUNCTION_PATH, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            authorization: jwt ? `Bearer ${jwt}` : '',
            apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({
            prompt_id: input.prompt_id,
            org_id: input.org_id,
            system: input.system,
            messages: input.messages,
            model: input.model,
            max_tokens: input.max_tokens ?? 1024,
            temperature: input.temperature ?? 0.4,
        }),
    });
    const body = await r.json().catch(() => ({}));
    if (!r.ok) {
        throw new AIError(body?.error ?? 'ai_upstream', body?.message ?? `AI call failed (${r.status}).`, r.status);
    }
    const text = body?.content?.[0]?.text ?? '';
    return {
        text,
        model: body?.model ?? 'unknown',
        input_tokens: body?.usage?.input_tokens ?? 0,
        output_tokens: body?.usage?.output_tokens ?? 0,
        latency_ms: body?.latency_ms ?? 0,
        raw: body,
    };
}
